import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/components/image.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/utils/get-currency.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/ClickTracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/html-sanitizer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/lazy_component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/show-more.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ViewTracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/account/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryBanner"] */ "/app/src/views/category/category-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/category/category-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/compare-products/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/shoppable-banner/pin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/accordion-slider-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/category-carousel-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/hero-slider-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MatressLayerContent"] */ "/app/src/views/widgets/matress-layer-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/promotion-grid-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/promotion-slider-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/redirection-tabs-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/video-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/application-drawer/application-drawer-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/blog-cards/CardsSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/colored-info-cards/ColoredInfoCardsSwiper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/custom-form/bed-hotline-form.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/custom-form/personalized-appointment-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/custom-search/search-input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/documents-grid/DialogButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/feature-cards/CardsSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/partner-map/country_list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/pc-recommendations/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/product-group-cards/product-group-cards-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/promotion-grid-with-navbar/promotion-grid-with-navbar-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Item"] */ "/app/src/widgets/redirection-grid/grid-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/review-slider/review-slider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/special-feature-banner/word-limited-display.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/timeline/timeline-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/video-banner-carousel/video-banner-carousel-client.tsx");
